<template>
  <div id="tablePage">
    <!-- 物流提货查询 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <!-- <el-table-column
          prop="pickId"
          label="出库编号"
        >
        </el-table-column> -->
        <el-table-column
          prop="warehouseId"
          label="仓单号"
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品名称"
          min-width="100"
        >

        </el-table-column>
        <el-table-column
          prop="pickQuantity"
          label="商品数量"
        >
        </el-table-column>
        <el-table-column
          prop="weight"
          label="商品总重量"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="仓库名称"
        >
        </el-table-column>
        <el-table-column
          prop="pickStatus"
          label="状态"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.pickStatus | pickStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="responsibleName"
          label="收货人"
        >
        </el-table-column>
        <el-table-column
          prop="responsiblePhone"
          label="联系电话"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="收货地址"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="申请时间"
          width="90"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | dateFormateDay }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.pickStatus === 'W'" class="operation" @click="gettingData(scope.row)">修改</span>
            <span v-if="scope.row.pickStatus !== 'W'" class="operation" @click="viewLogist(scope.row)">查看物流</span>
            <span v-if="scope.row.pickStatus === 'S'" class="operation" style="margin-left: 15px" @click="confirmReceipt(scope.row)">确认收货</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="修改发货信息" width="400px" center :visible.sync="dialogFormVisible" class="mainDialog" :close-on-click-modal="false" :before-close="qxDialog">
      <div class="itemSearch">
        <span class="title">收货人</span>
        <div class="inputsWrap">
          <el-input v-model="transfer.consigneeName" placeholder="请输入收货人"></el-input>
        </div>
      </div>
      <div class="itemSearch">
        <span class="title">联系电话</span>
        <div class="inputsWrap">
          <el-input v-model="transfer.consigneePhone" maxlength="11" placeholder="请输入联系电话"></el-input>
        </div>
      </div>
      <div class="itemSearch">
        <span class="title">收货地址</span>
        <div class="inputsWrap">
          <el-input v-model="transfer.consigneeAddr" maxlength="30" placeholder="请输入收货地址"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="conBtn" :disabled="popupBtn" @click="tackAndLossConfirm">确定</el-button>
        <el-button class="canelBtn" @click="qxDialog">取消</el-button>
      </div>
    </el-dialog>
    <!-- 查看物流 -->
    <orderLogistics ref="orderLogistics" />
  </div>
</template>
<script>
/*global http protocol util*/
import { mapGetters } from 'vuex'
import orderLogistics from '@/components/base/orderLogistics/orderLogistics'
export default {
  components: {
    orderLogistics
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['warehouseId', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      checked: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      TradeListSum: {
        'bsFlag': '',
        'closePl': 0,
        'commodityCode': '',
        'commodityId': 0,
        'commodityName': '',
        'createTime': 0,
        'fee': 0,
        'firmId': 0,
        'holdDetailId': 0,
        'margin': 0,
        'ocFlag': '',
        'orderId': 0,
        'quantity': 0,
        'singlePrice': 0,
        'tqTip': 0,
        'tradeDay': 0,
        'tradeId': 0,
        'tradeType': 0,
        'updateTime': 0,
        'stampFee': 0
      },
      dialogFormVisible: false,
      popupBtn: false,
      transfer: {
        deliveryId: 0, // 仓单id
        consigneeName: '', // 收货人
        consigneePhone: '', // 联系方式
        consigneeAddr: '' // 收货地址
      },
      isNetWrong: false,
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  },

  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 点击修改
    gettingData(obj) {
      // 获取订单信息
      this.transfer = {
        deliveryId: obj.pickId, // 仓单id
        consigneeName: obj.responsibleName, // 收货人
        consigneePhone: obj.responsiblePhone, // 联系方式
        consigneeAddr: obj.address // 收货地址
      }
      // 显示弹窗
      this.dialogFormVisible = true
    },
    qxDialog() {
      this.dialogFormVisible = false
      this.popupBtn = false
      this.transfer = {
        deliveryId: 0, // 仓单id
        consigneeName: '', // 收货人
        consigneePhone: '', // 联系方式
        consigneeAddr: '' // 收货地址
      }
    },
    // 提货申请
    tackAndLossConfirm() {
      // const that = this
      if (this.popupBtn) {
        return
      }
      this.popupBtn = true
      if (!this.transfer.consigneeName) {
        this.$message('请输入收货人')
        this.popupBtn = false
        return
      } else if (!util.isCNName(this.transfer.consigneeName)) {
        this.$message('请输入正确的收货人')
        this.popupBtn = false
      } else if (!this.transfer.consigneePhone) {
        this.$message('请输入联系电话')
        this.popupBtn = false
        return
      } else if (!util.isPoneAvailable(this.transfer.consigneePhone)) {
        this.$message('请输入11位联系电话')
        this.popupBtn = false
      } else if (!this.transfer.consigneeAddr) {
        this.$message('请输入收货地址')
        this.popupBtn = false
        return
      } else {
        // if (this.APP_WINNY_NAME === '神农购销') {
        //   protocol.param_updateReceivingInfo.url = '/base-desk-manage/delivery/updateReceivingInfo'
        // } else {
        //   protocol.param_updateReceivingInfo.url = '/base-warehousereceipt/delivery/updateReceivingInfo'
        // }
        protocol.param_updateReceivingInfo.data = JSON.parse(JSON.stringify(this.transfer))
        http.gPost(protocol.param_updateReceivingInfo).then(response => {
          if (response.data) {
            const { code, message } = response.data
            if (code == '0') {
              setTimeout(() => {
                this.showData()
                this.popupBtn = false
                this.$message(message)
                this.dialogFormVisible = false
                this.transfer = {
                  deliveryId: 0, // 仓单id
                  consigneeName: '', // 收货人
                  consigneePhone: '', // 联系方式
                  consigneeAddr: '' // 收货地址
                }
              }, 1000)
            } else {
              this.popupBtn = false
              this.$message(message)
            }
          }
        })
      }
    },
    // item 提货记录信息
    viewLogist(item) {
      protocol.param_getLogistic.data.no = item.courierNo + ':' + item.responsiblePhone.slice(-4)
      protocol.param_getLogistic.data.type = item.courierName
      http
        .gPost(protocol.param_getLogistic)
        .then(response => {
          const { code, message, value } = response.data
          if (code === 0 || code === '0') {
            value.number = item.courierNo
            sessionStorage.setItem('logiticObj', JSON.stringify(value))
            sessionStorage.setItem('goodImg', value.logo)
            this.$refs.orderLogistics.getLogistic()
          } else {
            this.$message(message)
          }
        })
        .catch(() => {})
    },
    // 确认收货
    confirmReceipt(item) {
      protocol.param_confirmReceipt.data.deliveryId = item.pickId
      http
        .gPost(protocol.param_confirmReceipt)
        .then(response => {
          const { code, message } = response.data
          if (code === 0 || code === '0') {
            this.$message(message)
            this.pageData.currentPage = 1
            const that = this
            setTimeout(() => {
              that.showData()
            }, 800)
          } else {
            this.$message(message)
          }
        })
        .catch(() => {})
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      const params = JSON.parse(JSON.stringify(protocol.param_getPickList))
      params.data = {}
      params.data.page =
          this.pageData.currentPage - 1
      params.data.size =
          '' + this.pageData.pageSize
      params.data.firmId = this.sessionInfoGetter.firmId
      params.data.pickType = 'W'
      params.data.warehouseId = this.warehouseId // 搜索仓单号
      params.data.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'pickId' // "//排序属性"
        }
      ]
      http.gPost(params).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })

      // protocol.queryTradeListSum.data = protocol.queryUserClinches.data
      // http.gPost(protocol.queryTradeListSum).then(response => {
      //   if (response.data.code != 0) {
      //     this.$message({ message: response.data.message })
      //   }
      //   if (response.data) {
      //     if (response.data && response.data.code == '0') {
      //       this.TradeListSum = response.data.value
      //     }
      //   }
      // })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        // that.modifyTime(arrIndex, 'createTime')
        // that.modifyTime(arrIndex, 'updateTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserClinches.data.sort[0].direction = 'ASC'
      } else {
        protocol.queryUserClinches.data.sort[0].direction = 'DESC'
      }
      // protocol.queryUserClinches.data.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        this.eachSortChange(column.column.property)
        http.gPost(protocol.queryUserClinches).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.TradeListSum = response.data.value.sumData
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserClinches.data.sort[0].property = str)
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 3) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 7) { // 成交数量
          sums[index] = that.TradeListSum.quantity
          return
        }
        if (index === 8) { // 成交金额
          sums[index] = that.TradeListSum.funds
          return
        }
        // if (index === 10) { // 转让存货价
        //   sums[index] = that.TradeListSum.fee
        //   return
        // }
        if (index === 10) { // 利润
          sums[index] = that.TradeListSum.closePl
          return
        }
        if (index === 11) { // 印花税
          sums[index] = that.TradeListSum.stampFee
          return
        }
        if (index === 12) { // 手续费
          sums[index] = that.TradeListSum.fee
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
<style lang="scss" scoped>
.diveryDialog{
  /deep/.el-dialog{
    width:480px;
    border-radius: 8px;
    background-color:#FFFFFF!important;
  }
  /deep/.el-dialog__header{
    padding:30px 40px 10px;
  }
  /deep/.el-dialog__body{
    padding:10px 40px 20px;
    span{
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.9);
    }
  }
  /deep/.el-dialog__headerbtn{
    top: 30px;
    right: 40px;
    .el-dialog__headerbtn .el-dialog__close{
      font-size:22px;
      color: rgba(255, 255, 255, 0.2);
    }
  }
  .zr_dialog_input {
    margin-top:10px;
  }
  /deep/.el-input__inner{
    background-color:transparent;
  }
  /deep/.el-dialog__footer{
    text-align:center;
    .el-button{
      width: 112px;
      height: 46px;
      border-radius: 23px;
      border: none;
      background: #D94066;
      span{
        color:#ffffff;
      }
    }
    .surexBtn{
      background: #41B37D;
      margin-left: 38px;
    }
  }
}
</style>
